module.exports = __webpack_public_path__ + "static/media/icomanual_instalacion.603b4929.svg";